import React, { useContext, useEffect, useState } from 'react'
import {
  Skeleton,
  message,
  Table,
  Button,
  Drawer,
  Form,
  Spin,
  Select,
  Menu,
  Dropdown,
  Divider,
} from 'antd'
import {
  FilterOutlined,
  DownloadOutlined,
  DownOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import api, { pdfUrl } from '../../services/api'
import { Container, PageTitle } from '../../components'
import { Enviar, Cancelar } from '../../components/Buttons'
import { format } from 'date-fns'
import { Helmet } from 'react-helmet'
import { formatarMoeda } from 'services/utils'
import DatePicker from '../../components/DatePicker'
import AuthContext from 'contexts/auth'
import axios from 'axios'

const { Column } = Table

function RelatorioContratos() {
  const { user } = useContext(AuthContext)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [filtrados, setFiltrados] = useState([])
  const [attendants, setAttendants] = useState([])
  const [clients, setClients] = useState([])
  const [contracts, setContracts] = useState([])
  const [date, setDate] = useState(null)

  // const [checkedList, setCheckedList] = useState([])
  // const [indeterminate, setIndeterminate] = useState(true)
  // const [checkAll, setCheckAll] = useState(false)

  const [filterQuery, setFilterQuery] = useState({})

  useEffect(() => {
    loadData()
    loadClients()
    loadContracts()
  }, [])

  const loadData = async () => {
    await api
      .get(`/user?accessProfile=atendente`)
      .then(({ data }) => {
        setAttendants(data)
      })
      .catch(() => {
        message.error('Erro ao carregar os dados.')
      })
  }

  const loadClients = async (attendantId) => {
    await api
      .get(`/client`, {
        params: {
          attendantId,
        },
      })
      .then(({ data }) => {
        setClients(data)
      })
      .catch(() => {
        message.error('Erro ao carregar os dados.')
      })
  }

  const loadContracts = async (clientId) => {
    await api
      .get(`/contract/os`, {
        params: {
          clientId,
        },
      })
      .then(({ data }) => {
        setContracts(data)
      })
      .catch(() => {
        message.error('Erro ao carregar os dados.')
      })
  }

  const onClose = () => {
    setVisible(false)
  }

  const disabledDate = (current) => {
    return current && current < date
  }

  const exportTable = async () => {
    setLoading(true)
    const nameFile = `${format(filterQuery.startDate, 'dd-MM-yyyy')} à ${format(
      filterQuery.endDate ? filterQuery.endDate : new Date(),
      'dd-MM-yyyy'
    )}`
    await axios
      .post(
        `${pdfUrl}contracts-report/`,
        { user, data: filtrados },
        {
          responseType: 'blob',
        }
      )
      .then((response) => {
        message.success({
          content: 'Baixando PDF...',
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${nameFile}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const exportRow = async (record) => {
    setLoading(true)
    const nameFile = record.client.nomeFantasia
    await axios
      .post(
        `${pdfUrl}contracts-report/`,
        { user, data: [record] },
        {
          responseType: 'blob',
        }
      )
      .then((response) => {
        message.success({
          content: 'Baixando PDF...',
        })
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${nameFile}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onSubmit = async (value) => {
    setFilterQuery(value)
    setLoading(true)
    api
      .get(`reports/contracts/`, {
        params: {
          startDate: format(value.startDate, 'yyyy-MM-dd'),
          endDate: value.endDate ? format(value.endDate, 'yyyy-MM-dd') : null,
          attendantId: value.attendantId,
          clientId: value.clientId,
          contractId: value.contractId,
        },
      })
      .then(({ data }) => {
        setFiltrados(data)
      })
      .catch(() => {
        message.error('Algo inesperado ocorreu')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const menu = () => {
    return (
      <Menu>
        <Menu.Item key='1'>
          <Button icon={<DownloadOutlined />} onClick={exportTable}>
            Baixar Tabela - PDF
          </Button>
        </Menu.Item>
        <Menu.Item key='2'>
          <Button disabled={true} icon={<DownloadOutlined />}>
            Baixar Tabela - CSV
          </Button>
        </Menu.Item>
      </Menu>
    )
  }

  const menuTabela = (record) => (
    <Menu>
      <Menu.Item key='1'>
        <Button
          icon={<DownloadOutlined />}
          onClick={() => {
            exportRow(record)
          }}
        >
          Baixar Relatório
        </Button>
      </Menu.Item>
    </Menu>
  )

  return (
    <Container>
      <Helmet>
        <title>Arcke | Relatório - Faturamento</title>
      </Helmet>
      <Skeleton loading={false}>
        <PageTitle
          title='Relatório de Faturamento Simplificado por Contrato'
          extra={[
            <Dropdown
              key='1'
              trigger={['click']}
              disabled={false || filtrados.length < 1}
              overlay={menu}
              placement='bottomCenter'
            >
              <Button size='large'>
                Exportar Tabela <DownOutlined />
              </Button>
            </Dropdown>,
            <Button
              icon={<FilterOutlined />}
              type='primary'
              size='large'
              onClick={() => {
                setVisible(true)
              }}
              key='2'
            >
              Filtrar
            </Button>,
          ]}
        />
        <Table
          dataSource={filtrados}
          loading={loading}
          rowKey={(record) => record.client.id}
          size='middle'
          style={{ margin: 20 }}
        >
          <Column
            title='Nome'
            dataIndex='name'
            key='name'
            render={(_, record) => record.client.nomeFantasia}
          />
          <Column
            title='Contratos'
            dataIndex='contratos'
            key='contratos'
            render={(_, record) => record.contracts.length}
          />
          <Column
            title='Total'
            dataIndex='total'
            key='total'
            render={(_, record) => formatarMoeda(record.total)}
          />

          <Column
            title='Ações'
            dataIndex='actions'
            key='actions'
            render={(_, record) => (
              <Dropdown
                trigger={['click']}
                key='1'
                overlay={menuTabela(record)}
                placement='bottomCenter'
              >
                <Button icon={<SettingOutlined />}>Ações</Button>
              </Dropdown>
            )}
          />
        </Table>
        <Drawer
          visible={visible}
          onClose={onClose}
          width={550}
          title='Filtro de Relatório'
        >
          <Spin spinning={loading}>
            <Form form={form} layout='vertical' onFinish={onSubmit}>
              <Form.Item label='Responsável'>
                <Form.Item
                  name='attendantId'
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                  noStyle
                >
                  <Select
                    size='large'
                    showSearch
                    placeholder='Selecione...'
                    optionLabelProp='label'
                    optionFilterProp='children'
                    allowClear
                    maxTagCount='responsive'
                    onChange={loadClients}
                  >
                    {attendants.map((attendant) => (
                      <Select.Option
                        key={attendant.id}
                        value={attendant.id}
                        label={attendant.name}
                      >
                        {attendant.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form.Item>
              <Form.Item label='Cliente'>
                <Form.Item
                  name='clientId'
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                  noStyle
                >
                  <Select
                    size='large'
                    showSearch
                    placeholder='Selecione...'
                    optionLabelProp='label'
                    optionFilterProp='children'
                    allowClear
                    onChange={loadContracts}
                  >
                    {clients.map((client) => (
                      <Select.Option
                        key={client.id}
                        value={client.id}
                        label={client.nomeFantasia}
                      >
                        {client.nomeFantasia}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form.Item>
              <Form.Item label='Contrato'>
                <Form.Item
                  name='contractId'
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                  noStyle
                >
                  <Select
                    size='large'
                    showSearch
                    placeholder='Selecione...'
                    optionLabelProp='label'
                    optionFilterProp='children'
                    allowClear
                  >
                    {contracts.map((contract) => (
                      <Select.Option
                        key={contract.id}
                        value={contract.id}
                        label={contract.name}
                      >
                        {contract.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form.Item>
              <Form.Item label='Data de início' name='startDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  onChange={(value) => {
                    setDate(value)
                  }}
                  size='large'
                />
              </Form.Item>
              <Form.Item label='Data de finalização' name='endDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  disabled={date === null}
                  disabledDate={disabledDate}
                  size='large'
                />
              </Form.Item>
              <Divider style={{ borderColor: '#aaa' }} />
              <div style={{ display: 'flex' }}>
                <Enviar
                  disabled={date === null}
                  type='primary'
                  htmlType='submit'
                  style={{ flex: 1 }}
                  size='large'
                >
                  Gerar Relatório
                </Enviar>
                <Cancelar
                  danger
                  onClick={onClose}
                  style={{ flex: 1 }}
                  size='large'
                >
                  Cancelar
                </Cancelar>
              </div>
            </Form>
          </Spin>
        </Drawer>
      </Skeleton>
    </Container>
  )
}

export { RelatorioContratos }
